export default "__VITE_ASSET__131bcf30__"